module.exports = __webpack_public_path__ + "img/icon_home.1823e0b.webp";